import { render, staticRenderFns } from "./AreaDoUsuario.vue?vue&type=template&id=3bbfe9f9&scoped=true"
import script from "./AreaDoUsuario.vue?vue&type=script&lang=js"
export * from "./AreaDoUsuario.vue?vue&type=script&lang=js"
import style0 from "./AreaDoUsuario.vue?vue&type=style&index=0&id=3bbfe9f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbfe9f9",
  null
  
)

export default component.exports